import React, {Component} from "react"
import { Button, VStack, Box, Spacer, Link, Text, Divider, HStack, Icon, Image } from "@chakra-ui/react"
import { AddIcon, TimeIcon, ViewIcon, ChatIcon, QuestionIcon, SettingsIcon, EmailIcon } from '@chakra-ui/icons'
import { FiLogOut } from 'react-icons/fi'
import colors from '../../../theme/colors'

// Dashboard icon component
const DashboardIcon = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
    />
  </Icon>
)

// export default function Sidebar() {
//   return (
//     <List color="white" fontSize="1.2em" spacing={4}>
//       <ListItem>
//         <NavLink to="/">
//           <ListIcon as={CalendarIcon} color="white" />
//           Dashboard
//         </NavLink>
//       </ListItem>
//       <ListItem>
//         <NavLink to="create">
//           <ListIcon as={EditIcon} color="white" />
//           New Task
//         </NavLink>
//       </ListItem>
//       <ListItem>
//         <NavLink to="profile">
//           <ListIcon as={AtSignIcon} color="white" />
//           Profile
//         </NavLink>
//       </ListItem>
//     </List>
//   )
// }

class Sidebar extends Component {
  // Common button props - light sidebar with red accents
  getButtonProps = () => ({
    size: "md",
    variant: "ghost",
    color: colors.sidebar.text,
    fontWeight: "600",
    fontSize: "sm",
    borderRadius: "lg",
    py: 4,
    px: 4,
    h: "48px",
    borderLeft: "3px solid transparent",
    transition: "all 0.2s",
    _hover: {
      bg: colors.sidebar.hover,
      color: colors.sidebar.textHover,
      borderLeftColor: colors.sidebar.activeBorder,
      transform: 'translateX(2px)',
    },
    _active: {
      bg: colors.sidebar.active,
      transform: 'translateX(0px)'
    },
    width: "100%",
    justifyContent: "flex-start"
  })

  render () {
    const { userVersion } = this.props;
    const buttonProps = this.getButtonProps();

    return (
      <Box
        height={{ base: "auto", md: "100vh" }}
        display="flex"
        flexDirection="column"
        bg={colors.sidebar.background}
        borderRight="1px solid"
        borderColor={colors.sidebar.border}
        boxShadow="sm"
        position={{ base: "relative", md: "sticky" }}
        top={0}
      >
        {/* App Title Section - Enhanced with red accent */}
        <Box p={{ base: 4, md: 6 }} pb={{ base: 3, md: 4 }}>
          <HStack justify="center" spacing={3} mb={{ base: 4, md: 6 }}>
            <Box
              p={2}
              borderRadius="lg"
              bg={colors.sidebar.logoBg}
              boxShadow="sm"
            >
              <Image src="/volt_logo.png" boxSize={{ base: 6, md: 7 }} alt="Demos Platform Logo" />
            </Box>
            <Box>
              <Text
                fontSize={{ base: "xl", md: "2xl" }}
                fontWeight="700"
                color={colors.sidebar.text}
                letterSpacing="-0.025em"
              >
                Demos
              </Text>
              <Text
                fontSize="xs"
                color={colors.primary.main}
                fontWeight="600"
                textTransform="uppercase"
                letterSpacing="0.1em"
              >
                Platform
              </Text>
            </Box>
          </HStack>
          <Divider borderColor={colors.sidebar.divider} />
        </Box>
        
        {/* Navigation Section */}
        <Box px={4} flex="1" display="flex" flexDirection="column">
          <VStack spacing={2} align="stretch" width="100%" flex="1">
            {userVersion === 'guest' ? (
              <>
                {/* Guest mode - only show Indienen */}
                <Button
                  {...buttonProps}
                  leftIcon={<AddIcon />}
                  onClick = {() => {this.props.onRouteChange('indienen')}}
                  >Indienen
                </Button>

                <Spacer />

                <Button
                  {...buttonProps}
                  leftIcon={<Icon as={FiLogOut} />}
                  onClick = {this.props.onLogout}
                  >Uitloggen
                </Button>
              </>
            ) : userVersion === 'burger' ? (
              <>
                <Button
                  {...buttonProps}
                  leftIcon={<AddIcon />}
                  onClick = {() => {this.props.onRouteChange('suggestieIndienen')}}
                  >Indienen
                </Button>
                <Button
                  {...buttonProps}
                  leftIcon={<TimeIcon />}
                  onClick = {() => {
                    // Reset to first page when navigating to Historie
                    if (this.props.resetSuggestionsPage) {
                      this.props.resetSuggestionsPage();
                    }
                    this.props.onRouteChange('ingediendeSuggesties');
                  }}
                  >Historie
                </Button>
                <Button
                  {...buttonProps}
                  leftIcon={<EmailIcon />}
                  onClick = {() => {this.props.onRouteChange('berichten')}}
                  >Berichten
                </Button>

                <Spacer />

                <Button
                  {...buttonProps}
                  leftIcon={<SettingsIcon />}
                  onClick = {() => {this.props.onRouteChange('instellingen')}}
                  >Instellingen
                </Button>
                <Button
                  {...buttonProps}
                  leftIcon={<Icon as={FiLogOut} />}
                  onClick = {this.props.onLogout}
                  >Uitloggen
                </Button>
              </>
            ) : (
              <>
                <Button
                  {...buttonProps}
                  leftIcon={<DashboardIcon />}
                  onClick = {() => {this.props.onRouteChange('dashboard')}}
                  >Dashboard
                </Button>
                <Button
                  {...buttonProps}
                  leftIcon={<ViewIcon />}
                  onClick = {() => {this.props.onRouteChange('overzicht')}}
                  >Analyse
                </Button>
                <Button
                  {...buttonProps}
                  leftIcon={<ChatIcon />}
                  onClick = {() => {this.props.onRouteChange('alleSuggesties')}}
                  >Suggesties
                </Button>
                <Button
                  {...buttonProps}
                  leftIcon={<EmailIcon />}
                  onClick = {() => {this.props.onRouteChange('berichten')}}
                  >Berichten
                </Button>

                <Spacer />

                <Button
                  {...buttonProps}
                  leftIcon={<SettingsIcon />}
                  onClick = {() => {this.props.onRouteChange('instellingen')}}
                  >Instellingen
                </Button>
                <Button
                  {...buttonProps}
                  leftIcon={<Icon as={FiLogOut} />}
                  onClick = {this.props.onLogout}
                  >Uitloggen
                </Button>
              </>
            )}
          </VStack>
        </Box>
        
        {/* Support Section - Enhanced */}
        <Box p={{ base: 3, md: 4 }} pt={2} mt="auto">
          <Divider borderColor={colors.sidebar.divider} mb={{ base: 3, md: 4 }} />

          <Link href="mailto:support@metdemos.app" isExternal>
            <Button
              leftIcon={<QuestionIcon />}
              size="sm"
              variant="outline"
              fontWeight="500"
              fontSize="xs"
              borderRadius="lg"
              h="40px"
              borderColor={colors.sidebar.border}
              color={colors.sidebar.text}
              transition="all 0.2s"
              _hover={{
                  bg: colors.sidebar.hover,
                  borderColor: colors.primary.main,
                  color: colors.primary.main,
                  transform: 'translateY(-1px)',
                  boxShadow: 'sm'
              }}
              _active={{
                  transform: 'translateY(0px)'
              }}
              width="100%"
              justifyContent="center"
              >Hulp nodig?
            </Button>
          </Link>
        </Box>
      </Box>
    )
  }
}

export default Sidebar